import {Checkbox, DropdownControl, Field} from 'apstra-ui-common';
import {observer} from 'mobx-react';
import {FC, PropsWithChildren} from 'react';
import {Message} from 'semantic-ui-react';

import NumberInput from './NumberInput';
import PortsCount from './PortsCount';
import {HOMING_TYPES, LAG_MODES} from '../const';
import LinksGroup from '../store/LinksGroup';
import {SpeedType} from '../types';

import './LinksGroupSize.less';

type LinkGroupSizeProps = {
  showRailOptions: boolean;
  linksGroup: LinksGroup;
  maxSizePerSpeed: any;
  onPortClick: (speed: SpeedType) => void;
  railSpeed?: string;
  railIndexOptions?: any[];
  noRailReason?: string;
  trackChanges: (changes: any) => void;
  maxLinks: number;
  canLinkFirst: boolean;
  canLinkSecond: boolean;
  canLinkBoth: boolean;
  toggleIsRail: () => void;
  linksGroupOptions: any;
  canChangeIndex?: boolean;
}

const LinkGroupSize: FC<PropsWithChildren<LinkGroupSizeProps>> = ({linksGroup, maxSizePerSpeed,
  onPortClick, railSpeed, railIndexOptions, trackChanges, maxLinks, canLinkFirst, canLinkSecond, canLinkBoth,
  toggleIsRail, children, linksGroupOptions, showRailOptions, noRailReason, canChangeIndex = true}) => {
  const {toggleHoming, toggleSwitchLink, homingType} = linksGroupOptions;
  const railSwitchDisabled = !!railSpeed && railSpeed !== linksGroup.speedString || !!noRailReason;
  return (
    <>
      {noRailReason &&
        <Message warning className='re-rails-errors'>
          {noRailReason}
        </Message>
      }
      {showRailOptions &&
        <Field className='is-in-rail' disabled={railSwitchDisabled}>
          <Checkbox
            label='Is a Part of the Rail'
            checked={linksGroup.isInRail}
            onChange={toggleIsRail}
          />
        </Field>
      }
      <div className='re-links-form'>
        <PortsCount
          portsBySpeed={maxSizePerSpeed}
          selectedSpeed={linksGroup.speedString}
          onClick={railSpeed ? undefined : onPortClick}
          error={!linksGroup.speedString}
          showEmpty
          usedCount={+linksGroup.count}
          limitBy={railSpeed}
        />
        {
          showRailOptions && linksGroup.isInRail &&
            <Field label='Rail Index' className='rail-index'>
              {railIndexOptions &&
                <DropdownControl
                  size='small'
                  fluid
                  value={linksGroup.railIndex || 0}
                  options={railIndexOptions}
                  onChange={(value) => trackChanges({railIndex: +value, lagMode: LAG_MODES.NO_LAG})}
                  disabled={!canChangeIndex}
                />
              }
              {!railIndexOptions &&
                <div className='value'>{'New Rail Index'}</div>
              }
            </Field>
        }
        {
          (!showRailOptions || !linksGroup.isInRail) &&
            <>
              <Field label='Count' disabled={!linksGroup.speedString} required>
                <NumberInput
                  type='number'
                  size='small'
                  fluid
                  min={1}
                  max={maxLinks}
                  value={+linksGroup.count}
                  onChange={(event, {value}) => trackChanges({count: value})}
                />
              </Field>
              {
                homingType === HOMING_TYPES.LEFT_RIGHT &&
                  <Field label='Peer Switch' className='checkboxes' required>
                    <Checkbox
                      label='First'
                      checked={linksGroup.isAttachedToFirst}
                      disabled={!canLinkFirst}
                      onChange={() => toggleSwitchLink(true, canLinkBoth)}
                    />
                    <Checkbox
                      label='Second'
                      checked={linksGroup.isAttachedToSecond}
                      disabled={!canLinkSecond}
                      onChange={() => toggleSwitchLink(false, canLinkBoth)}
                    />
                  </Field>
              }
              {
                homingType === HOMING_TYPES.DOUBLE_SINGLE &&
                  <Field label='Attachemt Type' className='checkboxes' disabled={!canLinkBoth}>
                    <Checkbox
                      label='Dual-Homed'
                      checked={linksGroup.isDualAttached}
                      onChange={toggleHoming}
                    />
                  </Field>
              }
            </>
        }
        {children}
      </div>
    </>
  );
};

export default observer(LinkGroupSize);
